import { createApp } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
// import VueCookies from 'vue3-cookies'
import App from './App.vue';
import router from './router';
import store from './store';
import './index.css';
import VueTheMask from 'vue-the-mask';
// import ENV from "./config";
import Rollbar from 'rollbar';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'intl-tel-input/build/css/intlTelInput.css';
import VueGtag from 'vue-gtag';
import CONFIG from '@/config';
// import vue-braintree from 'vue-braintree'
// import VueGoogleMaps from '@fawmi/vue-google-maps'
import { showGTM } from '@/common/gtmHelpers';
import { createPinia } from 'pinia';
import CastlePlugin from '@/plugins/castle';

const pinia = createPinia();
const app = createApp(App);
app.use(router).use(store).use(pinia); //.use(VueCookies);
router.app = app;

// app.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyDD2qtG-MXiZKdiawkY1ut1YNOQ7pL0aCc',
//   },
//   autobindAllEvents: true,
// });
app.mount('#app');
app.use(VueTheMask);
app.use(VueToast);
app.use(CastlePlugin);

if (showGTM()) {
  app.use(
    createGtm({
      id: CONFIG.GTM,
      // queryParams: {
      //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
      //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
      //   gtm_preview: 'env-4',
      //   gtm_cookies_win: 'x',
      // },
      defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      nonce: '3837d8g37d', // Will add `nonce` to the script tag
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: true, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    })
  );
  app.use(
    VueGtag,
    {
      config: { id: 'G-JMQJW863YN' },
    },
    router
  );
}

if (process.env.NODE_ENV == 'production') {
  app.config.globalProperties.$rollbar = new Rollbar({
    accessToken: process.env.ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.ROLLBAR_ENV,
      client: {
        javascript: {
          source_map_enabled: true, // true by default

          // -- Add this into your configuration ---
          code_version: process.env.CODE_VERSION,
          // ---------------------------------------

          // Optionally have Rollbar guess which frames the error was
          // thrown from when the browser does not provide line
          // and column numbers.
          guess_uncaught_frames: true,
        },
      },
    },
  });

  app.config.errorHandler = (err, vm) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
  };
}
